import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export type ProtectedRouteProps = {
  /** Optional element to render while auth state is initializing */
  loadingFallback?: ReactNode;
  /** Optional path to redirect unauthenticated users to */
  redirectTo?: string;
  /** If true, treat expired tokens as unauthenticated and redirect */
  redirectOnExpired?: boolean;
};

export default function ProtectedRoute({
  loadingFallback = null,
  redirectTo = '/',
  redirectOnExpired = true,
}: ProtectedRouteProps) {
  const { isLoading, isAuthenticated, error } = useAuth();

  if (isLoading) {
    return <>{loadingFallback}</>;
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  if (redirectOnExpired && error?.kind === 'SESSION_EXPIRED') {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
